import React from 'react';
import { Box, Heading, Text } from '@chakra-ui/react';
import { theme as mythboundTheme } from '../../config/theme';

interface LegalPageLayoutProps {
  title: string;
  children: React.ReactNode;
}

export const LegalPageLayout: React.FC<LegalPageLayoutProps> = ({ title, children }) => {
  return (
    <Box
      minH="100vh"
      bg={mythboundTheme.colors.gradients.darkPortal}
      display="flex"
      justifyContent="center"
      alignItems="flex-start"
      py={{ base: 8, md: 12 }}
      px={{ base: 4, md: 8 }}
    >
      <Box
        maxW="960px"
        w="100%"
        bg={mythboundTheme.colors.secondary.parchment || '#f2e4c7'}
        borderRadius="lg"
        boxShadow={mythboundTheme.shadows?.glow || '0 0 24px rgba(0,0,0,0.35)'}
        border="1px solid rgba(0,0,0,0.08)"
        p={{ base: 6, md: 10 }}
        color={mythboundTheme.colors.primary.dark}
        fontFamily={mythboundTheme.typography.fontFamily.body}
        lineHeight="1.7"
      >
        <Heading
          as="h1"
          fontFamily={mythboundTheme.typography.fontFamily.heading}
          color={mythboundTheme.colors.primary?.gold || '#d9b555'}
          mb={6}
          size="lg"
        >
          {title}
        </Heading>
        <Text fontSize="md" whiteSpace="pre-line">
          {children}
        </Text>
      </Box>
    </Box>
  );
};

export default LegalPageLayout;
